import React, { useState, useEffect, useCallback, useRef } from "react";



import I from "../component/Icon";



import ConfirmDlg from "../component/ConfirmDialog";



import Bdg from "../component/Badge";



import SB from "../component/SearchBox";



import SchoolForm from "../component/SchoolForm";



import SchoolStudentsView from "../component/SchoolStudentsView";



import apiService from "../services/apiService";



const SCHOOL_API_BASE = "School";

const SCHOOL_BULK_UPLOAD_API = "SchoolBulkInsert/schoolExcelBulkInsert";

const SCHOOL_TEMPLATE_URL = `${import.meta.env.BASE_URL || "/"}School_Bulk_Upload_Template.xlsx`;



const PAGINATED_SCHOOL_API = `${SCHOOL_API_BASE}/getPaginatedSchool`;



const DISTRICT_API_URL = "DistrictMaster/getAllDistrictMasters?includeInActive=true";



const showNotification = (type, message) => {



  if (



    typeof document === "undefined" ||



    typeof window === "undefined"



  ) {



    return;



  }



  const existingNotification =



    document.getElementById(



      "schools-page-notification"



    );



  if (existingNotification) {



    existingNotification.remove();



  }



  const notification =



    document.createElement("div");



  notification.id =



    "schools-page-notification";



  notification.textContent =



    `${type === "success" ? "✓" : "✕"} ${message}`;



  Object.assign(



    notification.style,



    {



      position: "fixed",



      top: "20px",



      right: "20px",



      zIndex: "99999",



      minWidth: "280px",



      maxWidth: "420px",



      padding: "12px 16px",



      borderRadius: "8px",



      backgroundColor:



        type === "success"



          ? "#d1e7dd"



          : "#f8d7da",



      color:



        type === "success"



          ? "#0f5132"



          : "#842029",



      border:



        type === "success"



          ? "1px solid #badbcc"



          : "1px solid #f5c2c7",



      fontSize: "14px",



      fontWeight: "600",



      boxShadow:



        "0 4px 12px rgba(0,0,0,0.15)",



    }



  );



  document.body.appendChild(



    notification



  );



  window.setTimeout(() => {



    if (notification.parentNode) {



      notification.remove();



    }



  }, 3000);



};



const getApiErrorMessage = (



  error,



  fallback



) => {



  const data =



    error?.response?.data;



  if (



    typeof data === "string" &&



    data.trim()



  ) {



    return data;



  }



  if (



    data &&



    typeof data === "object"



  ) {



    if (



      data?.errors &&



      typeof data.errors === "object"



    ) {



      const validationErrors =



        Object.values(data.errors)



          .flat()



          .filter(Boolean)



          .join(" ");



      if (validationErrors) {



        return validationErrors;



      }



    }



    return (



      data?.failureReason ||



      data?.FailureReason ||



      data?.message ||



      data?.Message ||



      data?.title ||



      data?.error ||



      error?.message ||



      fallback



    );



  }



  return (



    error?.message ||



    fallback



  );



};



const extractArray = (result) => {



  if (Array.isArray(result)) { return result; }



  const output =



    result?.output ??



    result?.Output ??



    result?.data ??



    result?.Data ??



    result;



  if (Array.isArray(output)) { return output; }



  const nested =



    output?.result ??



    output?.Result ??



    output?.data ??



    output?.Data ??



    [];



  return Array.isArray(nested)



    ? nested



    : [];



};



const normalizeDistrict = (district) => {



  return {



    ...district,



    id: Number(



      district?.id ??



      district?.Id ??



      district?.districtId ??



      district?.DistrictId ??



      district?.districtMasterId ??



      district?.DistrictMasterId ??



      0



    ),



    name:



      district?.districtName ??



      district?.DistrictName ??



      district?.districtMasterName ??



      district?.DistrictMasterName ??



      district?.name ??



      district?.Name ??



      "",



  };



};



const normalizeSchool = (school) => {



  return {



    ...school,



    id:



      school?.id ??



      school?.Id ??



      school?.schoolId ??



      school?.SchoolId,



    schoolName:



      school?.schoolName ??



      school?.SchoolName ??



      "",



    stateId:



      Number(



        school?.stateId ??



        school?.StateId ??



        0



      ),



    districtId:



      Number(



        school?.districtId ??



        school?.DistrictId ??



        0



      ),



    talukaId:



      Number(



        school?.talukaId ??



        school?.TalukaId ??



        0



      ),



    district:



      school?.district ??



      school?.District ??



      school?.districtName ??



      school?.DistrictName ??



      "",



    totalStudents:



      school?.totalStudents ??



      school?.TotalStudents ??



      0,



    pinCode:



      school?.pinCode ??



      school?.PinCode ??



      0,



    address:



      school?.address ??



      school?.Address ??



      "",



    phoneNumber:



      school?.phoneNumber ??



      school?.PhoneNumber ??



      "",



    status:



      school?.isActive ??



      school?.IsActive ??



      school?.status ??



      school?.Status ??



      false,



  };



};



export default function SchoolsPage() {

  // Bulk school Excel: upload a real Excel file using the API's `file` form field.

  const [bulkUploadOpen, setBulkUploadOpen] = useState(false);

  const [bulkFile, setBulkFile] = useState(null);

  const [bulkUploading, setBulkUploading] = useState(false);

  const bulkFileInputRef = useRef(null);







  const [sub, setSub] =



    useState("list");



  const [sel, setSel] =



    useState(null);



  const [edit, setEdit] =



    useState(null);



  const [del, setDel] =



    useState(null);



  const [schools, setSchools] =



    useState([]);



  const [districts, setDistricts] =



    useState([]);



  const [q, setQ] =



    useState("");



  const [



    pageNumber,



    setPageNumber,



  ] = useState(1);



  const [pageSize] =



    useState(10);



  const [



    totalRecords,



    setTotalRecords,



  ] = useState(0);



  const [



    totalPages,



    setTotalPages,



  ] = useState(1);



  const pageNumbers = Array.from(



    { length: totalPages },



    (_, index) => index + 1



  );



  const [



    sortField,



    setSortField,



  ] = useState("SchoolName");



  const [



    sortDirection,



    setSortDirection,



  ] = useState("ASC");



  const [loading, setLoading] =



    useState(false);



  useEffect(() => {



    const controller =



      new AbortController();



    const loadDistricts =



      async () => {



        try {



          const response = await apiService.get(



            DISTRICT_API_URL



          );



          const result = response.data;



          const data =



            extractArray(result)



              .map(



                normalizeDistrict



              )



              .filter(



                (district) =>



                  district.id > 0 &&



                  district.name



              );



          console.log(



            "Normalized Districts:",



            data



          );



          setDistricts(data);



        } catch (error) {



          if (



            error?.name ===



            "AbortError"



          ) {



            return;



          }



          console.error(



            "District load error:",



            error



          );



          setDistricts([]);



          showNotification(



            "error",



            getApiErrorMessage(



              error,



              "Failed to load districts"



            )



          );



        }



      };



    loadDistricts();



    return () => {



      controller.abort();



    };



  }, []);



  const getDistrictName = (



    districtId



  ) => {



    if (!districtId) {



      return "-";



    }



    const district =



      districts.find(



        (item) =>



          Number(item.id) ===



          Number(districtId)



      );



    return (



      district?.name || "-"



    );



  };



  const loadSchools =



    useCallback(



      async (



        searchValue = q,



        currentPage =



          pageNumber,



        signal = undefined



      ) => {



        try {



          setLoading(true);



          const requestBody = {



            Page: currentPage,



            PageSize: pageSize,



            SearchTerm:



              searchValue && searchValue.trim()



                ? searchValue.trim()



                : "",



            SortDirection: sortDirection,



            SortField: sortField,



          };



          const response = await apiService.post(



            PAGINATED_SCHOOL_API,



            requestBody



          );



          const result = response.data;



          console.log(



            "Get Paginated School Response:",



            result



          );



          const isSuccess =



            result?.isSuccess ??



            result?.IsSuccess ??



            true;



          if (



            isSuccess ===



            false



          ) {



            throw new Error(



              result



                ?.failureReason ??



              result



                ?.FailureReason ??



              "Failed to load schools"



            );



          }



          const output =



            result?.output ??



            result?.Output ??



            result?.data ??



            result?.Data ??



            result;



          const schoolResult =



            output?.result ??



            output?.Result ??



            output?.data ??



            output?.Data ??



            [];



          const rowCountValue =



            output?.rowCount ??



            output?.RowCount ??



            output



              ?.totalRecords ??



            output



              ?.TotalRecords ??



            0;



          const records =



            Number(



              rowCountValue



            ) || 0;



          const normalizedSchools =



            Array.isArray(schoolResult)



              ? schoolResult



                .map(normalizeSchool)



                .filter(



                  (school) =>



                    school.status === true



                )



              : [];



          console.log(



            "Active Schools:",



            normalizedSchools



          );



          setSchools(normalizedSchools);



          console.log(



            "Normalized Schools:",



            normalizedSchools



          );



          setTotalRecords(



            records



          );



          const calculatedTotalPages =



            Math.max(



              1,



              Math.ceil(



                records /



                pageSize



              )



            );



          setTotalPages(



            calculatedTotalPages



          );



          if (



            records > 0 &&



            currentPage >



            calculatedTotalPages



          ) {



            setPageNumber(



              calculatedTotalPages



            );



          }



        } catch (error) {



          if (



            error?.name ===



            "AbortError"



          ) {



            return;



          }



          console.error(



            "Load schools error:",



            error



          );



          setSchools([]);



          setTotalRecords(0);



          setTotalPages(1);



          showNotification(



            "error",



            getApiErrorMessage(



              error,



              "Failed to load schools"



            )



          );



        } finally {



          if (



            !signal?.aborted



          ) {



            setLoading(false);



          }



        }



      },



      [



        q,



        pageNumber,



        pageSize,



        sortDirection,



        sortField,



      ]



    );



  useEffect(() => {



    const controller =



      new AbortController();



    const timer =



      setTimeout(() => {



        loadSchools(



          q,



          pageNumber,



          controller.signal



        );



      }, 350);



    return () => {



      clearTimeout(timer);



      controller.abort();



    };



  }, [



    pageNumber,



    q,



    sortField,



    sortDirection,



    loadSchools,



  ]);



  const handleSearchChange = (



    value



  ) => {



    setQ(value);



    setPageNumber(1);



  };



  const handleSort = (



    field



  ) => {



    if (



      sortField === field



    ) {



      setSortDirection(



        (previous) =>



          previous === "ASC"



            ? "DESC"



            : "ASC"



      );



    } else {



      setSortField(field);



      setSortDirection(



        "ASC"



      );



    }



    setPageNumber(1);



  };



  const closeBulkUpload = () => {

    if (bulkUploading) return;

    setBulkUploadOpen(false);

    setBulkFile(null);

    if (bulkFileInputRef.current) bulkFileInputRef.current.value = "";

  };



  const handleBulkFileChange = (event) => {

    const file = event.target.files?.[0] || null;

    if (!file) { setBulkFile(null); return; }

    if (!/\.(xlsx|xls)$/i.test(file.name)) {

      showNotification("error", "Please select an .xlsx or .xls Excel file.");

      event.target.value = "";

      setBulkFile(null);

      return;

    }

    setBulkFile(file);

  };



  const handleBulkUpload = async () => {

    if (bulkUploading) return;

    if (!bulkFile) {

      showNotification("error", "Select a filled Excel file before uploading.");

      return;

    }

    try {

      setBulkUploading(true);

      const formData = new FormData();

      formData.append("file", bulkFile, bulkFile.name);



      const response = await apiService.postFormData(

        "SchoolBulkInsert/schoolExcelBulkInsert",

        formData

      );

      const body = response?.data;

      if (body?.isSuccess === false || body?.IsSuccess === false || body?.status === "Error" || body?.Status === "Error") {

        throw new Error(body?.message || body?.Message || body?.failureReason || body?.FailureReason || "School bulk upload failed.");

      }

      showNotification("success", typeof body === "string" ? body : (body?.message || body?.Message || "Schools uploaded successfully."));

      setBulkUploadOpen(false);

      setBulkFile(null);

      if (bulkFileInputRef.current) bulkFileInputRef.current.value = "";

      setPageNumber(1);

      await loadSchools(q, 1);



  } catch (error) {

    console.log("HTTP Status:", error.response?.status);

    console.log("Backend Error:", error.response?.data);



    showNotification(

      "error",

      getApiErrorMessage(error, "School Excel upload failed")

    );

  } finally {

    setBulkUploading(false);

  }

  };



const doDelete =



  async () => {



    if (!del) {



      return;



    }



    try {



      const response =



        await apiService.delete(



          `${SCHOOL_API_BASE}/deleteSchool/${del.id}`



        );



      const result =



        response?.data;



      const isSuccess =



        result?.isSuccess ??



        result?.IsSuccess ??



        true;



      if (isSuccess === false) {



        throw new Error(



          result?.failureReason ||



          result?.FailureReason ||



          result?.message ||



          result?.Message ||



          "Failed to delete school"



        );



      }



      showNotification(



        "success",



        result?.message ||



        result?.Message ||



        "School deleted successfully"



      );



      setDel(null);



      if (



        schools.length === 1 &&



        pageNumber > 1



      ) {



        setPageNumber(



          (previous) =>



            previous - 1



        );



      } else {



        await loadSchools(



          q,



          pageNumber



        );



      }



    } catch (error) {



      console.error(



        "Delete school error:",



        error



      );



      showNotification(



        "error",



        getApiErrorMessage(



          error,



          "Failed to delete school"



        )



      );



    } finally {



      setDel(null);



    }



  };



if (sub === "add") {



  return (



    <SchoolForm



      title="Add School"



      onSave={async () => {



        setPageNumber(1);



        await loadSchools(



          q,



          1



        );



        setSub("list");



      }}



      onBack={() =>



        setSub("list")



      }



    />



  );



}



if (



  sub === "view" &&



  sel



) {



  return (



    <SchoolStudentsView



      school={sel}



      students={[]}



      onBack={() => {



        setSub("list");



        setSel(null);



      }}



    />



  );



}



if (



  sub === "edit" &&



  edit



) {



  return (



    <SchoolForm



      title="Edit School"



      initial={edit}



      onSave={async () => {



        await loadSchools(



          q,



          pageNumber



        );



        setSub("list");



        setEdit(null);



      }}



      onBack={() => {



        setSub("list");



        setEdit(null);



      }}



    />



  );



} return (



  <>
    <style>{`
      .schools-pagination-footer { min-width: 0; max-width: 100%; flex-wrap: wrap; }
      .schools-pagination-footer > div:first-child { flex: 0 0 auto; }
      .schools-pagination-footer .pagination-bar {
        flex: 1 1 320px; min-width: 0; max-width: 100%; width: auto;
        display: flex; align-items: center; justify-content: flex-end; overflow: hidden;
      }
      .schools-pagination-footer .pagination-bar > button { flex: 0 0 auto; }
      .schools-pagination-footer .pagination-numbers {
        display: flex; min-width: 0; max-width: 100%; flex: 0 1 auto;
        overflow-x: auto; overflow-y: hidden; white-space: nowrap;
        overscroll-behavior-x: contain; -webkit-overflow-scrolling: touch;
        scrollbar-width: thin;
      }
      .schools-pagination-footer .pagination-numbers > button { flex: 0 0 auto; }
      @media (max-width: 768px) {
        .schools-pagination-footer { flex-direction: column; align-items: stretch !important; gap: 10px !important; }
        .schools-pagination-footer > div:first-child { align-self: flex-start; }
        .schools-pagination-footer .pagination-bar { width: 100%; flex: 0 0 auto; justify-content: space-between; gap: 5px !important; }
        .schools-pagination-footer .pagination-bar > button { min-width: 53px !important; padding: 0 7px !important; font-size: 10px !important; }
        .schools-pagination-footer .pagination-numbers { flex: 1 1 0; }
        .schools-pagination-footer .pagination-numbers > button { min-width: 30px !important; }
      }
    `}</style>



    <div className="ph">



      <div className="ph-title">



        Schools Management



      </div>



      <div className="ph-sub">



        Manage all registered



        schools



      </div>



    </div>



    <div



      className="tb"



      style={{



        display: "flex",



        alignItems:



          "center",



        gap: 10,



        flexWrap: "wrap",



      }}



    >



      <SB



        value={q}



        onChange={



          handleSearchChange



        }



        placeholder="Search school..."



      />



      <button



        type="button"



        className="btn bp"



        onClick={() =>



          setSub("add")



        }



      >



        <I



          n="plus"



          s={14}



          c="#fff"



        />



        Add School



      </button>

      <button

        type="button"

        className="btn btn-g"

        onClick={() => setBulkUploadOpen(true)}

        title="Bulk upload schools using an Excel template"

      >

        <I n="upload" s={14} /> Upload Excel

      </button>



    </div>



    {/* RESULT INFO */}



    <div



      style={{



        marginBottom: 14,



        fontSize: 12,



        color:



          "var(--t3)",



      }}



    >



      {q.trim() ? (



        <>



          Search results



          for:{" "}



          <strong



            style={{



              color:



                "var(--t1)",



            }}



          >



            "{q}"



          </strong>



          {" • "}



          {totalRecords}{" "}



          record



          {totalRecords !==



            1



            ? "s"



            : ""}



        </>



      ) : (



        <>

        </>



      )}



    </div>



    {/* TABLE */}



    <div className="card">



      <div className="tw">



        <table>



          <thead>



            <tr>



              <th



                onClick={() =>



                  handleSort(



                    "SchoolName"



                  )



                }



                style={{



                  cursor:



                    "pointer",



                }}



              >



                School Name{" "}



                {sortField ===



                  "SchoolName" &&



                  (sortDirection ===



                    "ASC"



                    ? "▲"



                    : "▼")}



              </th>



              <th>



                District



              </th>



              {/* <th>



                  Students



                </th> */}



              <th>



                Phone



              </th>



              <th>



                Status



              </th>



              <th>



                Actions



              </th>



            </tr>



          </thead>



          <tbody>



            {loading ? (



              <tr>



                <td



                  colSpan={



                    6



                  }



                  style={{



                    textAlign:



                      "center",



                    padding:



                      "30px",



                  }}



                >



                  Loading...



                </td>



              </tr>



            ) : schools.length ===



              0 ? (



              <tr>



                <td



                  colSpan={



                    6



                  }



                  style={{



                    textAlign:



                      "center",



                    padding:



                      "32px",



                    color:



                      "var(--t3)",



                  }}



                >



                  🏫{" "}



                  {q.trim()



                    ? "No schools found for your search"



                    : "No schools found"}



                </td>



              </tr>



            ) : (



              schools.map(



                (



                  school,



                  index



                ) => (



                  <tr



                    key={



                      school.id ??



                      `${pageNumber}-${index}`



                    }



                    style={{



                      cursor:



                        "pointer",



                    }}



                    onClick={() => {



                      setSel(



                        school



                      );



                      setSub(



                        "view"



                      );



                    }}



                  >



                    {/* SCHOOL NAME */}



                    <td>



                      <span



                        className="tdb"



                        style={{



                          color:



                            "var(--p)",



                        }}



                      >



                        {school.schoolName ||



                          "-"}



                      </span>



                    </td>



                    {/* DISTRICT NAME */}



                    <td className="td2">



                      {school.district ||



                        getDistrictName(



                          school.districtId



                        )}



                    </td>



                    {/* STUDENTS */}



                    {/* <td>



                        {school.totalStudents ??



                          0}



                      </td> */}



                    {/* PHONE */}



                    <td>



                      {school.phoneNumber ||



                        "-"}



                    </td>



                    <td>



                      <Bdg



                        type={



                          school.status



                            ? "green"



                            : "yellow"



                        }



                        label={



                          school.status



                            ? "Active"



                            : "Inactive"



                        }



                      />



                    </td>



                    <td



                      onClick={(



                        event



                      ) =>



                        event.stopPropagation()



                      }



                    >



                      <div



                        className="ra"



                        style={{



                          display:



                            "flex",



                          alignItems:



                            "center",



                          gap: 6,



                          opacity: 1,



                          visibility:



                            "visible",



                        }}



                      >



                        <button



                          type="button"



                          className="btn btn-g btn-sm"



                          title="View Students"



                          onClick={(



                            event



                          ) => {



                            event.stopPropagation();



                            setSel(



                              school



                            );



                            setSub(



                              "view"



                            );



                          }}



                        >



                          <I



                            n="users"



                            s={11}



                          />



                        </button>



                        {/* EDIT */}



                        <button



                          type="button"



                          className="btn btn-g btn-sm"



                          title="Edit School"



                          onClick={async (



                            event



                          ) => {



                            event.stopPropagation();



                            try {



                              const response = await apiService.get(



                                `${SCHOOL_API_BASE}/getSchoolById/${school.id}`



                              );



                              const result = response.data;



                              const schoolData =



                                result?.output ??



                                result?.Output ??



                                result?.data ??



                                result?.Data ??



                                result;



                              setEdit(



                                normalizeSchool(



                                  schoolData



                                )



                              );



                              setSub(



                                "edit"



                              );



                            } catch (



                            error



                            ) {



                              console.error(



                                "Edit school error:",



                                error



                              );



                              showNotification(



                                "error",



                                getApiErrorMessage(



                                  error,



                                  "Failed to load school details"



                                )



                              );



                            }



                          }}



                        >



                          <I



                            n="edit"



                            s={11}



                          />



                        </button>



                        {/* DELETE */}



                        <button



                          type="button"



                          className="btn btn-d btn-sm"



                          title="Delete School"



                          onClick={(



                            event



                          ) => {



                            event.stopPropagation();



                            setDel(



                              school



                            );



                          }}



                        >



                          <I



                            n="trash"



                            s={11}



                          />



                        </button>



                      </div>



                    </td>



                  </tr>



                )



              )



            )}



          </tbody>



        </table>



      </div>



    </div>



    {!loading &&



      totalRecords > 0 && (



        <div



          className="schools-pagination-footer"
          style={{



            width: "100%",



            display: "flex",



            alignItems: "center",



            justifyContent: "space-between",



            gap: "16px",



            marginTop: "16px",



            padding: "12px 4px 4px",



            borderTop: "1px solid #eef2f7",



          }}



        >



          <div



            style={{



              display: "flex",



              alignItems: "center",



              whiteSpace: "nowrap",



              fontSize: "11px",



              lineHeight: "16px",



              color: "var(--t3)",



            }}



          >



            Showing{" "}



            <span



              style={{



                margin: "0 4px",



                fontWeight: 600,



                color: "var(--t2)",



              }}



            >



              {(pageNumber - 1) *



                pageSize +



                1}



            </span>



            –



            <span



              style={{



                margin: "0 4px",



                fontWeight: 600,



                color: "var(--t2)",



              }}



            >



              {Math.min(



                pageNumber * pageSize,



                totalRecords



              )}



            </span>



            {" "}of{" "}



            <span



              style={{



                marginLeft: "4px",



                fontWeight: 600,



                color: "var(--t2)",



              }}



            >



              {totalRecords}



            </span>



          </div>



          <div



            className="pagination-bar"
            style={{



              display: "flex",



              alignItems: "center",



              gap: "5px",



            }}



          >



            <button



              type="button"



              disabled={



                pageNumber === 1 ||



                loading



              }



              onClick={() =>



                setPageNumber(



                  (previous) =>



                    Math.max(



                      1,



                      previous - 1



                    )



                )



              }



              style={{



                height: "32px",



                minWidth: "66px",



                padding: "0 10px",



                display: "inline-flex",



                alignItems: "center",



                justifyContent: "center",



                gap: "3px",



                border: "1px solid #e2e8f0",



                borderRadius: "6px",



                background:



                  pageNumber === 1



                    ? "#f8fafc"



                    : "#fff",



                color:



                  pageNumber === 1



                    ? "#cbd5e1"



                    : "#475569",



                fontSize: "11px",



                fontWeight: 500,



                cursor:



                  pageNumber === 1



                    ? "not-allowed"



                    : "pointer",



                transition:



                  "all 0.15s ease",



              }}



            >



              <span



                style={{



                  fontSize: "16px",



                  lineHeight: 1,



                }}



              >



                ‹



              </span>



              Back



            </button>



            <div



              className="pagination-numbers"
              style={{



                display: "flex",



                alignItems: "center",



                gap: "4px",



              }}



            >



              {pageNumbers.map(



                (page) => (



                  <button



                    key={page}



                    type="button"



                    disabled={loading}



                    onClick={() =>



                      setPageNumber(page)



                    }



                    style={{



                      height: "32px",



                      minWidth: "32px",



                      padding: "0 9px",



                      display:



                        "inline-flex",



                      alignItems:



                        "center",



                      justifyContent:



                        "center",



                      border:



                        pageNumber ===



                          page



                          ? "1px solid #2563eb"



                          : "1px solid #e2e8f0",



                      borderRadius:



                        "6px",



                      background:



                        pageNumber ===



                          page



                          ? "#2563eb"



                          : "#fff",



                      color:



                        pageNumber ===



                          page



                          ? "#fff"



                          : "#475569",



                      fontSize: "11px",



                      fontWeight: 600,



                      cursor: loading



                        ? "not-allowed"



                        : "pointer",



                      transition:



                        "all 0.15s ease",



                    }}



                  >



                    {page}



                  </button>



                )



              )}



            </div>



            <button



              type="button"



              disabled={



                pageNumber >=



                totalPages ||



                loading



              }



              onClick={() =>



                setPageNumber(



                  (previous) =>



                    Math.min(



                      totalPages,



                      previous + 1



                    )



                )



              }



              style={{



                height: "32px",



                minWidth: "66px",



                padding: "0 10px",



                display: "inline-flex",



                alignItems: "center",



                justifyContent: "center",



                gap: "3px",



                border: "1px solid #e2e8f0",



                borderRadius: "6px",



                background:



                  pageNumber >=



                    totalPages



                    ? "#f8fafc"



                    : "#fff",



                color:



                  pageNumber >=



                    totalPages



                    ? "#cbd5e1"



                    : "#475569",



                fontSize: "11px",



                fontWeight: 500,



                cursor:



                  pageNumber >=



                    totalPages



                    ? "not-allowed"



                    : "pointer",



                transition:



                  "all 0.15s ease",



              }}



            >



              Next



              <span



                style={{



                  fontSize: "16px",



                  lineHeight: 1,



                }}



              >



                ›



              </span>



            </button>



          </div>



        </div>



      )}



    {bulkUploadOpen && (

      <div

        role="presentation"

        onClick={(event) => { if (event.target === event.currentTarget) closeBulkUpload(); }}

        style={{ position: "fixed", inset: 0, zIndex: 999999, background: "rgba(15,23,42,.55)", display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}

      >

        <div role="dialog" aria-modal="true" aria-label="Upload Schools Excel"

          style={{ width: "100%", maxWidth: 510, background: "#fff", borderRadius: 12, boxShadow: "0 20px 70px rgba(0,0,0,.2)", padding: 24 }}>

          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12 }}>

            <h3 style={{ margin: 0, fontSize: 19 }}>Upload Schools Excel</h3>

            <button type="button" className="btn btn-g btn-sm" onClick={closeBulkUpload} disabled={bulkUploading} aria-label="Close">✕</button>

          </div>

          <p style={{ color: "#64748b", fontSize: 13, marginTop: 12, lineHeight: 1.7 }}>

            Step 1: Download the Excel template. Enter one school per row. DistrictName and TalukaName must match existing master names. Do not change column headers.

          </p>

          <a href={SCHOOL_TEMPLATE_URL} download="School_Bulk_Upload_Template.xlsx"

            className="btn btn-g" style={{ display: "inline-flex", textDecoration: "none", marginBottom: 16 }}>

            ↓ Download Excel Template

          </a>

          <div style={{ borderTop: "1px solid #e2e8f0", paddingTop: 16 }}>

            <label htmlFor="schoolBulkExcelInput" style={{ display: "block", marginBottom: 8, fontSize: 13, fontWeight: 600 }}>

              Step 2: Choose filled Excel file (.xlsx / .xls)

            </label>

            <input id="schoolBulkExcelInput" ref={bulkFileInputRef} type="file" accept=".xlsx,.xls" onChange={handleBulkFileChange}

              disabled={bulkUploading} style={{ display: "block", width: "100%", fontSize: 13 }} />

            {bulkFile && <p style={{ color: "#166534", fontSize: 12, margin: "9px 0" }}>Selected: {bulkFile.name}</p>}

          </div>

          <div style={{ display: "flex", justifyContent: "flex-end", flexWrap: "wrap", gap: 10, marginTop: 24 }}>

            <button type="button" className="btn btn-g" disabled={bulkUploading} onClick={closeBulkUpload}>Cancel</button>

            <button type="button" className="btn bp" disabled={bulkUploading || !bulkFile} onClick={handleBulkUpload}>

              {bulkUploading ? "Uploading..." : "Upload Schools"}

            </button>

          </div>

          <p style={{ fontSize: 11, color: "#64748b", marginBottom: 0, marginTop: 14 }}>

            Rows with unmatched DistrictName/TalukaName can be skipped by the backend. Verify school records after upload.

          </p>

        </div>

      </div>

    )}







    {del && (



      <ConfirmDlg



        title="Delete School"



        msg={`Delete "${del.schoolName}"? This cannot be undone.`}



        onOk={doDelete}



        onCancel={() =>



          setDel(null)



        }



      />



    )}



  </>



);



}
